import React from "react";

export default function GanttRowLabel(props) {

  var {
    label,
    status,
    onClick
  } = props;

  function getStatusStyle(status) {

    if (status === "At Risk") {
      return {
        background: "linear-gradient(180deg, #f39c12 0%, #e67e22 100%)"
      };
    }

    if (status === "On Track") {
      return {
        background: "linear-gradient(180deg, #2e7d32 0%, #1b5e20 100%)"
      };
    }

    if (status === "In Progress") {
      return {
        background: "linear-gradient(180deg, #546e7a 0%, #37474f 100%)"
      };
    }

    if (status === "Planned") {
      return {
        background: "linear-gradient(180deg, #616161 0%, #424242 100%)"
      };
    }

    if (status === "Complete") {
      return {
        background: "linear-gradient(180deg, #1565c0 0%, #0d47a1 100%)"
      };
    }

    return {
      background: "linear-gradient(180deg, #757575 0%, #424242 100%)"
    };
  }

  return (
    <div style={styles.container} onClick={onClick}>

      {/* LABEL */}
      <span style={styles.label}>
        {label}
      </span>

      {/* STATUS PILL */}
      <span
        style={{
          ...styles.status,
          ...getStatusStyle(status)
        }}
      >
        {status}
      </span>

    </div>
  );
}

/* ================= STYLES ================= */

const styles = {

  container: {
    display: "flex",
    alignItems: "center",
    width: "100%",
    height: "100%",
    gap: "10px",
    boxSizing: "border-box",     // 👈 IMPORTANT
   
  },

  label: {
    fontSize: "13px",
    fontWeight: 500,
    color: "rgba(255,255,255,0.92)",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    flex: 1
  },

  status: {
    padding: "4px 10px",
    borderRadius: "12px",
    fontSize: "11px",
    fontWeight: 600,
    color: "#ffffff",
    whiteSpace: "nowrap",
    minWidth: "74px",
    textAlign: "center",
    boxShadow: "0 1px 2px rgba(0,0,0,0.35)",
    marginLeft: "auto"
  }
};


